import React from 'react';
import { useServiceWorker } from '../../hooks/use-service-worker';

export const UpdateNotification: React.FC = () => {
  const {
    isUpdateAvailable,
    currentVersion,
    isLoading,
    applyUpdate,
    checkForUpdates
  } = useServiceWorker();

  const handleUpdate = async () => {
    try {
      await applyUpdate();
    } catch (error) {
      console.error('Update failed:', error);
    }
  };

  const handleCheckUpdate = async () => {
    try {
      await checkForUpdates();
    } catch (error) {
      console.error('Update check failed:', error);
    }
  };

  // Only show notification when there's an update available
  if (!isUpdateAvailable) {
    return null; // Don't render anything when no update is available
  }

  return (
    <div className="update-notification">
      <div className="notification-content update-available">
        <h4>🔄 App Update Available</h4>
        <p>A new version is available. Update now to get the latest features and improvements.</p>
        
        <div className="update-actions">
          <button 
            onClick={handleUpdate}
            className="btn btn-primary"
            disabled={isLoading}
          >
            {isLoading ? 'Updating...' : 'Update Now'}
          </button>
          
          <button 
            onClick={handleCheckUpdate}
            className="btn btn-outline-secondary"
            disabled={isLoading}
          >
            Check Again
          </button>
        </div>
        
        <div className="update-info">
          <small>
            <strong>Current Version:</strong> {currentVersion} | 
            <strong>New Version:</strong> Available
          </small>
        </div>
      </div>


    </div>
  );
};
